import React from 'react';
import { Helmet } from 'react-helmet';

function ReactHelmet({ keywords = '', description = '', title = '', author = '', page_name = '' }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <meta name="meta_author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="naver-site-verification" content="" />
      <meta name="google-site-verification" content="" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:page_name" content={page_name} />
      <meta property="og:description" content={description} />
      {/* <meta property="og:image" content="" /> */}
      <meta property="og:url" content="" />
    </Helmet>
  );
}

export default ReactHelmet;
